import snakeCase from "lodash/snakeCase";

export default function persist(values) {
    // create a copy
    values = Object.assign({}, values);

    if (values.icon !== null && values.icon !== '') {
        // if not the snake_case version is passed
        // https://www.notion.so/Changer-l-icone-de-m-thode-de-livraison-9504b48a5b054a78bf1dd6999815b3a1?pvs=4#db2f729e2d2f4e7f8ee355e70a06bb4e
        values.icon = snakeCase(values.icon);
    }

    // we don't want null additionalData from other shipping methods like carrierId, customerNumber...
    if (values.additionalData) {
        for (const [key, value] of Object.entries(values.additionalData)) {
            if (value === null) {
                delete values.additionalData[key];
            }
        }
    }

    return values;
}
